import React, { useEffect, useState } from 'react';
import {
  Modal,
  Divider,
  Form,
  Row,
  Col,
  InputNumber,
  notification,
  Card,
} from 'antd';
import getEnvValue from 'utils/getEnvValue';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import OfferInput from 'pages/ProposalV3/PropDetail/OfferInput';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import { shouldUpdateCompare } from 'utils/utils2';
import PricingInput from 'pages/ProposalV3/PropDetail/PricingInput';
import Button from 'components/Button';
import { isNil } from 'lodash';
import FVContextUseSelect from './FVContextUseSelect';
import {
  AssetUseConditionRequest,
  calculateAssetFutureValue,
  createAssetFutureValue,
  PaymentSchedule,
} from 'services/assets';
import AssetFVScheduleModal from './AssetFVScheduleModal';
import IrvScheduleButton from 'components/IrvScheduleButton';
import AssetDVuseScheduleModal from './AssetFVUseContextSchModal';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  prFilteringCriteria,
} from 'services/pricing';

type AddAssetFVModalProps = {
  onAdd: (line: any) => void;
  visible: boolean;
  onClose: () => void;
  assetDetail: any;
  usecondition: Array<AssetUseConditionRequest>;
  attributeList:Array<FilteringCriteria>;
  irvSchedule: any;
  fromproposal: any;
  proposalData?: any;
  refetchassetFV?: () => void;
};
const initialValues = {
  prcode: '',
  offerid: '' as any,
  ofrid: '' as any,
  duration: '' as any,
};
const AddAssetFVModal = (props: AddAssetFVModalProps) => {
  const {
    onAdd,
    visible,
    onClose,
    assetDetail,
    usecondition,
    attributeList,
    irvSchedule,
    refetchassetFV,
    fromproposal,
    proposalData,
  } = props;

  const [isLoading, setisLoading] = useState(false);

  const [isDisableSaveButton, setDisableSaveButton] = useState(true);

  const [form] = useForm();

  const save = async () => {
    setisLoading(true);

    await createAssetFutureValue({
      request: form.getFieldValue('assetFutureValue')?.data,
    })
      .then((res) => {
        notification.success({ message: res.message });
        form.setFieldsValue({ assetFutureValue: res });
        setisLoading(false);
        setDisableSaveButton(true);
        refetchassetFV && refetchassetFV();
        onClose();
      })
      .catch((res) => {
        form.setFieldsValue({ assetFutureValue: res });
        notification.error({ message: res.message });
        setisLoading(false);
        setDisableSaveButton(false);
      });
  };

  const getFilterList = (): prFilteringCriteria => {
    let assetList = [assetDetail];

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;
    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });
    assetList?.forEach((a: any) => {  
      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'ASSETPRD',
        critvalue: a.assetsegment,
      });

      offerCriteriaList.push({
        critcode: 'ASSETMODEL',
        critvalue: a.assetmodel,
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });
    });

    if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
      usecondition?.forEach((u: any) => {
        assetUseCriteriaList.push({
          assetfamily: assetDetail.assetfamily,
          assettype: assetDetail.assettype,
          assetcategory: assetDetail.assetcategory,
          catalogid: assetDetail.catalogid ?? '',
          attcode: u.attcode ?? '',
          attvalue: u.usevalue ?? '',
        });
      });
    }
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer: assetDetail.tpidmanufacturer??0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria:assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const calculate = async () => {
    let data: any = {};
    setisLoading(true);
    const paymentSchedule: Array<PaymentSchedule> = irvSchedule?.map(
      (irvLine: any) => ({
        ctstype: irvLine.ctstype,
        ctsduedate: irvLine.enddate,
        ctsstartdate: irvLine.startdate,
        ctsenddate: irvLine.enddate,
        ctsoutstandingamount: irvLine.finrvamount,
        ctsorder: '' as any,
        ctsterm: '' as any,
        ctsperiodicity: '' as any,
        ctsperiodicityunit: '' as any,
        ctsstartamount: '' as any,
        ctsamortizedamount: '' as any,
        ctsinterestamount: '' as any,
        ctsrentalamount: '' as any,
      })
    );

    await calculateAssetFutureValue({
      request: {
        assetnetamount: assetDetail.assetnetamount,
        parcontextid: form.getFieldValue('context'),
        assetid: assetDetail.assetid,
        contextid: '' as any,
        duration: form.getFieldValue('duration'),
        mode: 'INIT',
        newmarketvalue: '' as any,
        newvaluedate: '' as any,
        proctaskid: '' as any,
        useCondition: usecondition,
        paymentSchedule: paymentSchedule ?? ([] as any),
      },
    })
      .then((res) => {
        if (res.code === '200') {
          notification.success({ message: res.message });
          form.setFieldsValue({ assetFutureValue: res });
          setisLoading(false);
          setDisableSaveButton(false);
        } else {
          setDisableSaveButton(true);
        }
      })
      .catch((res) => {
        form.setFieldsValue({ assetFutureValue: res });
        notification.error({ message: res.message });
        setisLoading(false);
      });
  };

  useEffect(() => {
    if (fromproposal) {
      form.setFieldsValue({
        prcode: proposalData.prcode ?? ('' as any),
        offerid: proposalData.offerid ?? ('' as any),
        pricing: proposalData.pricing ?? ('' as any),
        duration: proposalData.duration ?? ('' as any),
      });
    }
  }, []);

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      width={600}
      title={
        <GetLabel label="AddAssetFutureValue" Inspectstyle={{ width: '97%' }} />
      }
      footer={null}
    >
      <Card>
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
        >
          <Row gutter={32}>
            <FormInput col xs={24} md={12} name="prcode">
              <ProductInput
                onChange={(e) => {
                  form.setFieldsValue({
                    offerid: null,
                    pricing: null,
                    context: null,
                  });
                }}
              />
            </FormInput>
            <FormInput col xs={24} md={12} name="duration">
              <InputNumber />
            </FormInput>
          </Row>
          <Row gutter={32}>
            <Form.Item
              shouldUpdate={shouldUpdateCompare(['prcode', 'duration'])}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput col xs={24} md={12} name="offerid">
                  <OfferInput
                    allowClear
                    params={{
                      prcode: getFieldValue('prcode'),
                      filtersList: getFilterList(),
                      filters: '',
                      finamount: 0,
                      duration: getFieldValue('duration'),
                      searchMode: 'PRCODE',
                    }}
                    onChange={(e) => {
                      form.setFieldsValue({
                        pricing: null,
                        context: null,
                      });
                    }}
                  />
                </FormInput>
              )}
            </Form.Item>
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'prcode',
                'duration',
                'offerid',
              ])}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput col xs={24} md={12} name="pricing">
                  <PricingInput
                    params={{
                      catalogid: 0,
                      duration: getFieldValue('duration'),
                      filtersList: getFilterList(),
                      filters: '',
                      finamount: 0,
                      mgid: Number(localStorage.getItem('mgid')) ?? 0,
                      offerid: getFieldValue('offerid'),
                      prcode: getFieldValue('prcode'),
                    }}
                    allowClear
                    onChange={(e) => {
                      form.setFieldsValue({
                        context: null,
                      });
                    }}
                  />
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={32}>
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'prcode',
                'duration',
                'offerid',
                'pricing',
                'duration',
              ])}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput col xs={24} md={12} name="context">
                  <FVContextUseSelect
                    allowClear
                    paramsprops={{
                      prcode: getFieldValue('prcode') ?? ('' as any),
                      offerid: getFieldValue('offerid') ?? ('' as any),
                      ofrtype: getFieldValue('pricing')?.ofrtype ?? ('' as any),
                      ofrid: getFieldValue('pricing')?.ofrid ?? ('' as any),
                      catalogid: assetDetail.catalogid,
                      assetfamily: assetDetail.assetfamily,
                      assettype: assetDetail.assettype,
                      assetcategory: assetDetail.assetcategory,
                      assetmodel:assetDetail.assetmodel,
                      assetsegment:assetDetail.assetsegment,
                      duration: getFieldValue('duration') ?? ('' as any),
                      mode: 'INIT',
                      attributeList:!isNil(attributeList)?attributeList: ([] as any),
                      useCondition: !isNil(usecondition)
                        ? usecondition
                        : ([] as any),
                    }}
                  />
                </FormInput>
              )}
            </Form.Item>
            <Col span={12} style={{ marginTop: '1rem' }}>
              <Form.Item shouldUpdate={shouldUpdateCompare('context')} noStyle>
                {({ getFieldValue }) => {
                  return (
                    <Button
                      disabled={isNil(getFieldValue('context'))}
                      loading={isLoading}
                      comcode="calculate"
                      type="primary"
                      onClick={calculate}
                    />
                  );
                }}
              </Form.Item>
            </Col>
          </Row>
          <Divider>Calculation Result</Divider>
          <Row gutter={32}>
            <Col span={8}>
              {form.getFieldValue('assetFutureValue')?.code === '200'
                ? form.getFieldValue('assetFutureValue')?.message
                : 'Please enter simulation values'}
            </Col>
            <Col span={8}>
              {form.getFieldValue('assetFutureValue')?.code === '200' && (
                <AssetDVuseScheduleModal
                  AssetfvcontextuseResponse={
                    form.getFieldValue('assetFutureValue')?.data?.fvContextUse
                  }
                  controller={<Button comcode="ListFVContextUse" />}
                />
              )}
            </Col>
            <Col span={8}>
              {form.getFieldValue('assetFutureValue')?.code === '200' && (
                <AssetFVScheduleModal
                  assetfvschedule={
                    form.getFieldValue('assetFutureValue')?.data?.fvSchedule
                  }
                  controller={
                    <IrvScheduleButton
                      comcode="FVScheduleButton"
                      twoToneColor="red"
                      style={{
                        height: 50,
                        width: '100%',
                      }}
                    />
                  }
                />
              )}
            </Col>
          </Row>
          <Divider />
          <Row gutter={32}>
            <Button comcode="Cancel" onClick={onClose} />
            <Button
              type="primary"
              comcode="Save"
              disabled={isDisableSaveButton}
              onClick={save}
            />
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default AddAssetFVModal;
